import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    // {
    //   path: "*",
    //   redirect: "/"
    // },
    // {
    //   path: "/",
    //   name: "PageView",
    //   component: resolve => require(["@/view/PageView"], resolve),
    //   children: [
    //     {
    //       path: "/",
    //       redirect: "/home"
    //     },
    //     {
    //       path: "/home",
    //       name: "home",
    //       component: resolve => require(["@/view/HomePage"], resolve)
    //     },
    //     {
    //       path: "/software",
    //       name: "software",
    //       component: resolve => require(["@/view/Software"], resolve)
    //     },
    //     {
    //       path: "/MoreList",
    //       name: "MoreList",
    //       component: resolve => require(["@/view/MoreList"], resolve)
    //     },
    //     {
    //       path: "/ArticleDetails",
    //       name: "ArticleDetails",
    //       component: resolve => require(["@/view/ArticleDetails"], resolve)
    //     }
    //   ]
    // }
    {
      path: "/",
      redirect: "/home",
      component: () => import('@/view/HomePage')
    },
    {
      path: "/home",
      name: "home",
      component: () => import('@/view/HomePage')
    },
    {
      path: "/software",
      name: "software",
      component: () => import('@/view/Software')
    },
    {
      path: "/MoreList",
      name: "MoreList",
      component: () => import('@/view/MoreList')
    },
    {
      path: "/ArticleDetails",
      name: "ArticleDetails",
      component: () => import('@/view/ArticleDetails')
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js